module.exports = __webpack_public_path__ + "static/media/faqs@1x.1ad1da09.webm";